/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum InfoChartStatusEnum {
    CLOSED = 'CLOSED',
    OPEN = 'OPEN',
    UNKNOWN = 'UNKNOWN',
    ACTIVE = 'ACTIVE',
    MOUSE_HOVER = 'MOUSE_HOVER'
}
